export default __webpack_public_path__ + "static/media/logo.580694d1.svg";